import PersonalDetails from './personalDetails.view';

export default PersonalDetails;
